import components from './JbcFront.json'
export default  { 'jbc-front': components }